import { ONBOARDING_ACTIONS } from "constants/actions";

export function fetchCasesList(stage, page, page_size, type, filters) {
    return {
        type: ONBOARDING_ACTIONS.FETCH_CASES_LIST,
        payload: {
            stage,
            page,
            page_size,
            type,
            filters
        }
    };
}

export function fetchedCasesList(stage, page, page_size, data) {
    return {
        type: ONBOARDING_ACTIONS.FETCHED_CASES_LIST,
        payload: {
            stage,
            page,
            page_size,
            data: data
        }
    };
}

export function failedFetchCasesList(stage, page, page_size, error) {
    return {
        type: ONBOARDING_ACTIONS.FAILED_FETCH_CASES_LIST,
        payload: {
            stage,
            page,
            page_size
        },
        error: error
    };
}


export function clearWorkflowCaseDetail() {
    return {
        type: ONBOARDING_ACTIONS.CLEAR_WORKFLOW_CASE_DETAIL,
       
    };
}
export function fetchWorkflowCaseDetail(id) {
    return {
        type: ONBOARDING_ACTIONS.FETCH_WORKFLOW_CASE_DETAIL,
        payload: {
            id
        }
    };
}

export function fetchedWorkflowCaseDetail(data) {
    return {
        type: ONBOARDING_ACTIONS.FETCHED_WORKFLOW_CASE_DETAIL,
        payload: {
            data
        }
    };
}

export function failedFetchWorkflowCaseDetai(error) {
    return {
        type: ONBOARDING_ACTIONS.FAILED_FETCH_CASE_DETAIL,
        payload: {
            error
        },
        error: error
    };
}

export function fetchCompanyBackground(company_id, mpa_approval_id) {
    return {
        type: ONBOARDING_ACTIONS.FETCH_COMPANY_BACKGROUND,
        payload: {
            company_id, 
            mpa_approval_id
        }
    };
}

export function fetchedCompanyBackground(data) {
    return {
        type: ONBOARDING_ACTIONS.FETCHED_COMPANY_BACKGROUND,
        payload: {
            data
        }
    };
}

export function failedFetchCompanyBackground(error) {
    return {
        type: ONBOARDING_ACTIONS.FAILED_FETCH_COMPANY_BACKGROUND,
        payload: {
            error
        },
        error: error
    };
}

export function fetchDeviationMatrix(mpa_approval_id) {
    return {
        type: ONBOARDING_ACTIONS.FETCH_DEVIATION_MATRIX,
        payload: {
            mpa_approval_id
        }
    };
}

export function fetchedDeviationMatrix(data) {
    return {
        type: ONBOARDING_ACTIONS.FETCHED_DEVIATION_MATRIX,
        payload: {
            data
        }
    };
}

export function failedFetchDeviationMatrix(error) {
    return {
        type: ONBOARDING_ACTIONS.FAILED_FETCH_DEVIATION_MATRIX,
        payload: {
            error
        },
        error: error
    };
}

export function fetchCasePendencyDetail(actionDetailId) {
    return {
        type: ONBOARDING_ACTIONS.FETCH_CASE_PENDENCY_DETAIL,
        payload: {
            actionDetailId
        }
    };
}

export function fetchedCasePendencyDetail(data) {
    return {
        type: ONBOARDING_ACTIONS.FETCHED_CASE_PENDENCY_DETAIL,
        payload: {
            data
        }
    };
}

export function failedFetchCasePendencyDetail(error) {
    return {
        type: ONBOARDING_ACTIONS.FAILED_FETCH_CASE_PENDENCY_DETAIL,
        payload: {
            error
        },
        error: error
    };
}